import { preAuth } from 'common/api/auth';

import {
    INIT_AUTH,
    INIT_AUTH_FAILURE,
    INIT_AUTH_SUCCESS,
} from '../actionTypes';
import { loginActions } from '../reducer';

import setAuthValues from './setAuthValues';
import showSecondStepAuthForm from './showSecondStepAuthForm';

export default (data) => (dispatch) => {
    dispatch(loginActions[INIT_AUTH]());

    preAuth(data)
        .then((response) => {
            dispatch(loginActions[INIT_AUTH_SUCCESS](response.data));

            dispatch(
                setAuthValues({
                    ...data,
                    validationToken: response.data.auth_token,
                }),
            );

            dispatch(showSecondStepAuthForm(true));
        })
        .catch((error) =>
            dispatch(
                loginActions[INIT_AUTH_FAILURE](error?.response?.data?.errors),
            ),
        );
};
